import { Routes, Route, BrowserRouter as Router } from 'react-router-dom';
import { Home, Navbar, PostDetail, CreatePost } from './index';
function App() {
  return (
    <div className="container">
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/post/:postId" element={<PostDetail />} />
        <Route path="/create-post" element={<CreatePost />} />
      </Routes>
    </div>
  );
}

export default App;
